<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
          <div class="w-100" style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;">
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      <h6>Message status</h6>
      <hr>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="sentDate" inputId="sentDate" appendTo="body" readonly="true" [disabled]="true">
            </p-calendar>
            <label for="sentDate">Sent Date</label>
            @for (validation of validationMessages.sentDate; track validation) {
              <span>
                @if (form1.get('sentDate').hasError(validation.type) && (form1.get('sentDate').dirty || form1.get('sentDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="receivedDate" inputId="receivedDate" appendTo="body" readonly="true" [disabled]="true">
            </p-calendar>
            <label for="receivedDate">Received Date</label>
            @for (validation of validationMessages.receivedDate; track validation) {
              <span>
                @if (form1.get('receivedDate').hasError(validation.type) && (form1.get('receivedDate').dirty || form1.get('receivedDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name" optionValue="value"
            placeholder="status"></p-dropdown>
            <label for="status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="statusMsg" id="statusMsg" type="text" pInputText/>
            <label for="statusMsg">Status Message</label>

            @for (validation of validationMessages.statusMsg; track validation) {
              <span>
                @if (form1.get('statusMsg').hasError(validation.type) && (form1.get('statusMsg').dirty || form1.get('statusMsg').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="confId" id="confId" type="text"  readonly="true" pInputText/>
            <label for="confId">Conf Id</label>
            @for (validation of validationMessages.confId; track validation) {
              <span>
                @if (form1.get('confId').hasError(validation.type) && (form1.get('confId').dirty || form1.get('confId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="trackingId" id="trackingId" type="text" readonly="true" pInputText/>
            <label for="trackingId">Tracking Id</label>
            @for (validation of validationMessages.trackingId; track validation) {
              <span>
                @if (form1.get('trackingId').hasError(validation.type) && (form1.get('trackingId').dirty || form1.get('trackingId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="opsNotes" id="opsNotes" type="text" pInputText/>
            <label for="opsNotes">Operational Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="senderName" id="senderName" type="text" pInputText/>
            <label for="senderName">Sender Name</label>

            @for (validation of validationMessages.senderName; track validation) {
              <span>
                @if (form1.get('senderName').hasError(validation.type) && (form1.get('senderName').dirty || form1.get('senderName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="senderEmail" id="senderEmail" type="email" pInputText/>
            <label for="senderEmail">Sender Email</label>
            @for (validation of validationMessages.senderEmail; track validation) {
              <span>
                @if (form1.get('senderEmail').hasError(validation.type) && (form1.get('senderEmail').dirty || form1.get('senderEmail').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="subject" id="subject" type="text" pInputText/>
            <label for="subject">Subject</label>
            @for (validation of validationMessages.subject; track validation) {
              <span>
                @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="preHeader" id="preHeader" type="text" pInputText readonly="true"/>
            <label for="preHeader">preHeader</label>
            @for (validation of validationMessages.preHeader; track validation) {
              <span>
                @if (form1.get('preHeader').hasError(validation.type) && (form1.get('preHeader').dirty || form1.get('preHeader').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <label for="emailHtml">Email Html</label>
          <span class="p-float-label required-field w-100 mb-3">
          <editor formControlName="emailHtml" id="emailHtml1" [init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.emailHtml; track validation) {
              <span>
                @if (form1.get('emailHtml').hasError(validation.type) && (form1.get('emailHtml').dirty || form1.get('emailHtml').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-12">
          <span class="fp-float-label required-field w-100 mb-3">
            <label for="emailText">Email Text</label>
            <textarea formControlName="emailText" id="emailText" [rows]="3" pInputTextarea></textarea>
            @for (validation of validationMessages.emailText; track validation) {
              <span>
                @if (form1.get('emailText').hasError(validation.type) && (form1.get('emailText').dirty || form1.get('emailText').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <textarea formControlName="headers" id="headers" [rows]="1" pInputTextarea readonly="true"></textarea><label
          for="headers">Headers</label>
          @for (validation of validationMessages.headers; track validation) {
            <span>
              @if (form1.get('headers').hasError(validation.type) && (form1.get('headers').dirty || form1.get('headers').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <hr>
        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="countries" formControlName="senderCountryCode" optionLabel="name"
            optionValue="dial" placeholder="Country Code"></p-dropdown>
            <label for="senderCountryCode">Sender Country</label>
            @for (validation of validationMessages.senderCountryCode; track validation) {
              <span>
                @if (form1.get('senderCountryCode').hasError(validation.type) && (form1.get('senderCountryCode').dirty || form1.get('senderCountryCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-8">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <p-inputMask formControlName="senderMobileNum" id="senderMobileNum" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="senderMobileNum" id="senderMobileNum" type="text" pInputText>
          <label for="senderMobileNum">Sender Mobile Number</label>
          @for (validation of validationMessages.senderMobileNum; track validation) {
            <span>
              @if (form1.get('senderMobileNum').hasError(validation.type) && (form1.get('senderMobileNum').dirty || form1.get('senderMobileNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="mobileText" id="mobileText" type="text" pInputText/>
          <label for="mobileText">Mobile Text</label>
          @for (validation of validationMessages.mobileText; track validation) {
            <span>
              @if (form1.get('mobileText').hasError(validation.type) && (form1.get('mobileText').dirty || form1.get('mobileText').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="topic" id="topic" type="text" pInputText/>
          <label for="topic">Topic</label>
          @for (validation of validationMessages.topic; track validation) {
            <span>
              @if (form1.get('topic').hasError(validation.type) && (form1.get('topic').dirty || form1.get('topic').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="topicId" id="topicId" type="text" pInputText/>
          <label for="topicId">topicId</label>
          @for (validation of validationMessages.topicId; track validation) {
            <span>
              @if (form1.get('topicId').hasError(validation.type) && (form1.get('topicId').dirty || form1.get('topicId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      @if (msgId) {
        <app-msg-recipient-list [msgId]="msgId" [showPagination]= "false" [showFilter]="false" (recipientSelected)="updateEmailRecipients($event)"
        [msgId]="msgId"></app-msg-recipient-list>
      }

    </div>
  </div>
  <hr />
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (msgId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Close</button>
          @if (!msgId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (msgId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
          }
          @if (msgId) {
            <button pButton  class="btn-addt p-button" (click)="sendMail()">Send</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
